import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { TWInput } from '../../../components/TWInput';
import { signup as signUpAction } from '../../../state/actions';
import { Button } from '../../../subkit-ui';
import { validateEmail } from '../../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageSignup = function LandingPageSignup(_ref) {
  var redirectHref = _ref.redirectHref,
      buttonText = _ref.buttonText,
      signup = _ref.signup,
      onSignupSubmit = _ref.onSignupSubmit;
  var router = useRouter();

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(''),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = useState(false),
      valid = _useState3[0],
      setValid = _useState3[1];

  var onChange = function onChange(event) {
    setEmail(event.target.value);
    setValid(validateEmail(event.target.value));
  };

  var handleClick = function handleClick(e) {
    e.preventDefault();
    setLoading(true);
    onSignupSubmit();
    signup({
      email: email,
      redirect: redirectHref,
      agreedToTerms: false
    }).then(function () {
      router.push('/confirm-email');
    })["catch"](function () {
      setLoading(false);
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "mx-auto px-4 md:px-0 max-w-full md:max-w-half xl:max-w-2/5 md:flex md:flex-row md:items-end",
    children: [/*#__PURE__*/_jsx("div", {
      className: "md:flex-1 md:mx-auto md:max-w-md",
      children: /*#__PURE__*/_jsx(TWInput, {
        label: "Email",
        inputType: "email",
        name: "email",
        onChange: onChange,
        dataCy: "landing-signup-input",
        placeholder: "Enter email address",
        value: email
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4 md:mt-0 md:ml-7 w-full md:w-56",
      children: /*#__PURE__*/_jsx(Button, {
        text: loading ? 'Loading...' : buttonText,
        disabled: !valid || loading,
        type: "primary",
        onClick: handleClick,
        classes: "py-3 px-12",
        size: "lg"
      })
    })]
  });
};

var mapStateToProps = function mapStateToProps() {
  return {// (state: IStore) => ({
    // loading: state.auth.loading,
    // currentUser: state.auth.users.current,
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    signup: function signup(payload) {
      return dispatch(signUpAction(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPageSignup);